import { useSelector } from 'react-redux';

import {
    Icon,
    Platform,
    React,
    StyleSheet,
    Title,
    TouchableWithoutFeedback,
    View
} from '../../common';
import { modal as styles } from '../../common/style';
import { TabSwitch } from '../../common/TabSwitch';
import { getMapType } from '../../selectors';
import { COLORS } from '../../styles/colors';
import {
    colorScaleStyles,
    switchMapModalStyles
} from './styles';

export const ColorScale = React.memo(
    ({
        maxValue,
        minValue,
        colors,
        onPress,
        unit,
        fixedValues,
        hasCorrectValues = fixedValues && fixedValues.length === colors.length,
    }) => (
        <TouchableWithoutFeedback onPress={onPress}>
            <View style={[ colorScaleStyles.scale, { backgroundColor: colors[colors.length - 1] } ]}>
                {colors.map((color, i) => (
                    <View
                        key={color}
                        style={[
                            colorScaleStyles.color,
                            { backgroundColor: color },
                            hasCorrectValues && colorScaleStyles.fixedValueWrapper,
                        ]}
                    >
                        {hasCorrectValues ? <Title style={colorScaleStyles.valueText}>{fixedValues[i]}</Title> : null}
                    </View>
                ))}
                {hasCorrectValues ? null : (
                    <View style={colorScaleStyles.values}>
                        <Title style={colorScaleStyles.valueText}>{`${minValue} ${unit}`}</Title>
                        <Title style={colorScaleStyles.valueText}>{`${maxValue} ${unit}`}</Title>
                    </View>
                )}
            </View>
        </TouchableWithoutFeedback>
    ),
);

export const SwitchMapModal = ({
    onChange,
    onClose,
    isWeb = Platform.OS === 'web',
}) => {
    const mp = useSelector(getMapType);
    const tabData = [
        {
            id: 'standard',
            isActive: mp === 'standard',
            name: Object.R('titles.layersSwitchStandard'),
        },
        {
            id: 'hybrid',
            isActive: mp === 'hybrid',
            name: Object.R('titles.layersSwitchHybrid'),
        },
        {
            id: 'satellite',
            isActive: mp === 'satellite',
            name: Object.R('titles.layersSwitchSatellite'),
        },
    ];
    const card = (
        <View
            style={[ styles.container,
                switchMapModalStyles.switch,
                isWeb ? { marginTop: 12 } : {},
                !isWeb ? switchMapModalStyles.nativeLayerCardZ : null ]}
            accessibilityLabel="modal"
        >
            <View style={switchMapModalStyles.header}>
                <Title
                    id="titles.layers"
                    style={switchMapModalStyles.headerTitle}
                />
                <Icon
                    name="cross"
                    onPress={onClose}
                    style={switchMapModalStyles.headerCrossIcon}
                />
            </View>
            <TabSwitch
                containerStyle={[ switchMapModalStyles.tabSwitch, isWeb ? { width: '95%' } : {} ]}
                data={tabData}
                onChange={onChange}
            />
        </View>
    );

    if (!isWeb) {
        return (
            <View style={switchMapModalStyles.switchWrapper}>
                <TouchableWithoutFeedback onPress={onClose}>
                    <View
                        style={[
                            StyleSheet.absoluteFillObject,
                            { backgroundColor: 'rgba(0,0,0,0.7)' },
                        ]}
                    />
                </TouchableWithoutFeedback>
                {card}
            </View>
        );
    }

    return (
        <TouchableWithoutFeedback onPress={onClose}>
            <View style={switchMapModalStyles.switchWrapper}>
                {card}
            </View>
        </TouchableWithoutFeedback>
    );
};

export const UserLocationMarkerWeb = () => {
    return (
        <View
            style={{
                width: 12,
                height: 12,
                background: COLORS.MAIN,
                borderRadius: 50,
                borderColor: 'white',
                borderWidth: 1,
                shadowColor: COLORS.DARK_GRAY,
                shadowOpacity: 0.7,
                shadowRadius: 5,
                elevation: 5,
            }}
        />
    );
};
